import React, {Component} from 'react';
import {Session, QuotationDetailModel} from "../../components";
import {DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config} from "../../libs/utils/Const";
import {ApiClient} from "../../libs/apiClient/ApiClient";
import {connect} from "react-redux";
import moment from 'moment';
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';

const apiClient = ApiClient.getInstance();

require('datatables.net-bs4');

class QuotaionViews extends Component {

    state = {
        orders: [],
        order: {
            header: {},
            body: []
        },
    };

    async componentDidMount() {
        const {enableSpinner} = this.props;
        enableSpinner(true);
        let response = await apiClient.getQuotation();

        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                orders: response.data,
            });
            $('#tablaQuotation').DataTable({
                "paging": false,
                "info": false,
                "searching": false
            });
        }

    }

    openOrder = async docEntry => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;
        enableSpinner(true);
        let response = await apiClient.getDataQuotation(docEntry);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: response.data,
            });

            $('#quotationModal').modal('show');
            return;
        }

        showAlert({type: 'error', message: "Aviso: "+response.message})
    };

    docChangeName(status){
        let result = '';
        switch (status) {
            case 'O':
                result = "Abierta";
                break;
            case 'C':
                result = "Cerrada";
                break;
            default:
                break;
        }
        return result;
    };

    render() {
        const {orders, order} = this.state;
        return (
            <div className="content-fluid">
                <QuotationDetailModel order={order}/>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                    <div className="col-md-12">
                        <h3>Cotizaciones</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <table id="tablaQuotation" class="table table-striped">
                            <thead>
                                <tr style={{backgroundColor: config.shoppingList.summaryList, color: "white"}}>
                                    <th scope="col">No. de cotización</th>
                                    <th scope="col">Fecha de creación</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Valor total</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order, index) => {
                                    return (<tr key={index}>
                                        <th scope="row">{order.DocNum}</th>
                                        <td>{moment(order.Fecha).format('DD-MM-YYYY')}</td>
                                        <td>{this.docChangeName(order.DocStatus)}</td>
                                        <td className="text-right">
                                            <CurrencyFormat 
                                                value={order.Total} 
                                                displayType={'text'} 
                                                thousandSeparator={'.'}
                                                decimalSeparator={','}
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        </td>
                                        <td>
                                            <sapn onClick={() => this.openOrder(order.DocEntry)}>
                                                <i className={config.icons.detail} style={{color: config.shoppingList.summaryList, paddingRight: 6}}></i>
                                                Detalle
                                            </sapn>
                                        </td>
                                    </tr>)
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuotaionViews);